// extracted by mini-css-extract-plugin
export default {"info":"style_info__b11YJ","eventTitle":"style_eventTitle__KYoys","dateInscription":"style_dateInscription__7Sqid","section":"style_section__IpbwJ"};